document.addEventListener("DOMContentLoaded", () => {
  // The classic Konami Code sequence using standard JavaScript event.key names
  const konamiCode = [
    "ArrowUp",
    "ArrowUp",
    "ArrowDown",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowLeft",
    "ArrowRight",
    "b",
    "a",
  ];

  let currentPosition = 0;

  document.addEventListener("keydown", (event) => {
    // Normalize the key press (in case they have Caps Lock on for B and A)
    let key = event.key;
    if (key === "B" || key === "A") {
      key = key.toLowerCase();
    }

    // Check if the key matches the next required key in the sequence
    if (key === konamiCode[currentPosition]) {
      currentPosition++;

      // If they completed the whole sequence
      if (currentPosition === konamiCode.length) {
        triggerShopifyEasterEgg();
        currentPosition = 0; // Reset so they can do it again
      }
    } else {
      // If they mess up, reset the sequence.
      // But if the wrong key was 'ArrowUp', start the sequence over smoothly.
      currentPosition = key === konamiCode[0] ? 1 : 0;
    }
  });

  // What happens when they crack the code!
  function triggerShopifyEasterEgg() {
    const siteBody = document.body;
    // This adds the CSS class to the body of your site
    siteBody.classList.toggle("easter-egg-cursor");

    // Hide scrollbars temporarily
    siteBody.style.overflow = "hidden";

    siteBody.style.transition = "transform 5s ease-in-out";
    siteBody.style.transform = "rotate(1080deg)";

    setTimeout(() => {
      siteBody.style.transition = "none";
      siteBody.style.transform = "rotate(0deg)";

      // Bring scrollbars back!
      siteBody.style.overflow = "";
    }, 3000);
  }
});
